/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - JSON</h2>
    <p className={styles.description}>
      <a className={styles.link} href="https://www.json.org/json-en.html" target="_blank" rel="noopener noreferrer">
        JSON{' '}
      </a>
      — современный формат хранения и передачи данных.
    </p>
    <p className={styles.description}>
      Объектоподобный синтаксис JSON очень удобен. Именно в этом формате данные будут приходить и отправляться на
      сервер, сохраняться в локальном хранилище и т. п.{' '}
    </p>
    <p className={styles.description}>
      JSON можно рассматривать как строковое представление JavaScript-объекта. Поддерживает следующие значения:{' '}
      <code className={styles.code}>string</code>, <code className={styles.code}>number</code>,{' '}
      <code className={styles.code}>object</code>, <code className={styles.code}>array</code>,{' '}
      <code className={styles.code}>boolean</code>, <code className={styles.code}>null</code>.{' '}
    </p>
    <p className={styles.description}>
      Ниже приведен пример JSON-файла. Он очень похож на объекты, за исключением того, что ключи и все кроме:{' '}
      <code className={styles.code}>чисел</code>, <code className={styles.code}>булей</code>,{' '}
      <code className={styles.code}>null</code>, <code className={styles.code}>литерала массива</code> и{' '}
      <code className={styles.code}>объекта</code>, всегда должны быть в двойных кавычках.{' '}
    </p>
    <CopyBlock
      text={`{
  "name": "Josh",
  "weight": 175,
  "age": 30,
  "eyecolor": "brown",
  "isHappy": true,
  "cars": ["Chevy", "Honda"],
  "favoriteBook": {
    "title": "When the Fire Nation Attacked",
    "author": "Nickelodeon",
    "released": "02-21-2005"
  }
}`}
      language="js"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>
      Javascript и JSON отлично работают вместе благодаря методам <code className={styles.code}>JSON.stringify()</code>{' '}
      и <code className={styles.code}>JSON.parse()</code>. Они преобразуют JS-объект в JSON и обратно, и независимо от
      того, что у вас есть, можно легко получить обратное.
    </p>
    <a className={styles.link} href="https://jsonlint.com/" target="_blank" rel="noopener noreferrer">
      Онлайн JSON-валидатор
    </a>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.1 - Метод JSON.stringify(obj)</h3>
      <p className={styles.description}>
        Чтобы использовать <code className={styles.code}>JSON.stringify()</code>, просто передайте JavaScript-объект,
        который необходимо преобразовать в JSON.{' '}
      </p>
      <CopyBlock
        text={`const dog = {
  name: 'Mango',
  age: 3,
  isHappy: true,
};

const dogJSON = JSON.stringify(dog);
console.log(dogJSON); // {"name":"Mango","age":3,"isHappy":true}`}
        language="js"
        showLineNumbers={false}
        theme={ocean}
      />

      <p className={styles.description}>
        <code className={styles.code}>JSON.stringify(dog)</code> взял объект <code className={styles.code}>dog</code> и
        преобразовал его в строку. Эта строка теперь валидный JSON и может быть сохранена в файл или передана по сети.{' '}
      </p>
    </section>
    <section className={styles.subsection}>
      <h3 className={styles.h3}>3.2 - Метод JSON.parse(string)</h3>
      <p className={styles.description}>
        Чтобы получить JavaScript-объект из JSON, вы должны разобрать (распарсить) его, операция обратная{' '}
        <code className={styles.code}>stringify</code>.{' '}
      </p>
      <CopyBlock
        text={`const json = '{"name":"Mango","age":3,"isHappy":true}';

const dog = JSON.parse(json);
console.log(dog); // {name: "Mango", age: 3, isHappy: true}`}
        language="js"
        showLineNumbers={false}
        theme={ocean}
      />
      <p className={styles.description}>
        Теперь, когда <code className={styles.code}>dog</code> является обычным JavaScript-объектом, его можно
        использовать.{' '}
      </p>
    </section>
  </section>
))
